if (!customElements.get('s-slideshow-hero')) {
  customElements.define(
    's-slideshow-hero',
    class SectionSlideshowHero extends HTMLElement {
      connectedCallback() {
        this.covers1 = this.querySelectorAll('.image-1');
        this.covers2 = this.querySelectorAll('.image-2');
        this.covers3 = this.querySelectorAll('.image-3');

        if (!this.covers1.length && !this.covers2.length && !this.covers3.length) return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });
        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.resetTransforms();
      }

      handleScroll = () => {
        const scrollOffset = Math.max(0, -this.getBoundingClientRect().top);

        this.covers1.forEach((el) => {
          el.style.transform = `rotate(-3.52deg) translateY(${0.3 * scrollOffset}px)`;
        });

        this.covers2.forEach((el) => {
          el.style.transform = `rotate(2.361deg) translateY(${0.4 * scrollOffset}px)`;
        });

        this.covers3.forEach((el) => {
          el.style.transform = `rotate(10.273deg) translateY(${0.5 * scrollOffset}px)`;
        });
      };

      resetTransforms() {
        this.covers1?.forEach((el) => {
          el.style.transform = 'rotate(-3.52deg)';
        });

        this.covers2?.forEach((el) => {
          el.style.transform = 'rotate(2.361deg)';
        });

        this.covers3?.forEach((el) => {
          el.style.transform = 'rotate(10.273deg)';
        });
      }
    }
  );
}
